import homepage from './homepage/index';
import news from './homepage/news';
import subscription from './lp/subscription';
import subscription_form from './lp/subscription_form';
import subscription_done from './lp/subscription_done';
import web from './lp/web';
import trial from './lp/trial';
import lp from './lp/lp';
import limited from './lp/limited';
import employee from './lp/employee';
import trial_form from './lp/trial_form';
import trial_pc_form from './lp/trial_pc_form';
import trial_form_candidates from './lp/trial_form_candidates';
import trial_done from './lp/trial_done';
import trial_pc_done from './lp/trial_pc_done';
import campaign_common from './lp/campaign_common';
import campaign_common_form from './lp/campaign_common_form';
import mjpm from './lp/mjpm';
import mjpm_form from './lp/mjpm_form';
import mjpm_done from './lp/mjpm_done';
import logout from './logout';
import cast_agreement from './cast/agreement';
import cast_agreements from './cast/agreements';
import cast_done from './cast/done';
import admin_login from './admin/login';
import admin_users from './admin/users';
import admin_users_deleted from './admin/users_deleted';
import admin_casts from './admin/casts';
import admin_reservations from './admin/reservations';
import admin_debug from './admin/debug';

const exportedObject = {
  homepage,
  news,
  subscription,
  subscription_form,
  subscription_done,
  web,
  trial,
  lp,
  limited,
  employee,
  trial_form,
  trial_pc_form,
  trial_form_candidates,
  trial_done,
  trial_pc_done,
  campaign_common,
  campaign_common_form,
  mjpm,
  mjpm_form,
  mjpm_done,
  logout,
  cast_agreement,
  cast_agreements,
  cast_done,
  admin_login,
  admin_users,
  admin_users_deleted,
  admin_casts,
  admin_reservations,
  admin_debug
}

export default exportedObject